import React from "react";

export const Family = (props) => {
  return (
    <div id="family">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/family.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="family-text">
              <h2>Unsere Familie</h2>
              <p 
                dangerouslySetInnerHTML={{ __html: props.data ? props.data.paragraph : "loading..." }}
                style={{ textAlign: 'justify' }}
              ></p>
              <div className="text-center">
                <a 
                  href="https://familie.fritta-haas.de/"
                  className="btn btn-custom"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Familien-Stammbaum
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
